import { makeStyles } from "@material-ui/core";
import ImagemMapa from 'assets/img/mapa.png';

export const useStyles = makeStyles((theme) => ({
  mapContainer: {
    '& img': {
      width: '100%',
      height: '100%',
      borderRadius: theme.shape.borderRadius
    },
    position: 'relative'
  },
  mapContainerExpanded: {
    position: 'absolute',
    width: '100%',
    top: '15px',
    bottom: 0,
    left: 0,
    right: 0
  },
  mapImage: {
    backgroundImage: `url(${ImagemMapa})`,
    width: '100%',
    height: 'calc(100% - 50px)',
    maxHeight: '510px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    boxShadow: '0px 0px 17px 10px inset rgb(255 255 255 / 50%)',
    border: '1px solid #ddd'
  },
  banner: {
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.text.secondary,
    fontWeight: 'bold',
    borderRadius: theme.shape.borderRadius,
    minHeight: 285
  },
  titulos: {
    color: theme.palette.secondary.main,
    fontWeight: 700
  },
  descricao: {
    color: theme.palette.common.white,
    fontWeight: 500,

  },
  bannerContent: {
    backgroundColor: theme.palette.primary.dark,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(4, 2)
  },
  textoDestaque: {
    color: theme.palette.common.white,
  },
  contentButton: {
    display: 'flex',
    position: "absolute",
    bottom: 0,
    right: 0,
    padding: theme.spacing(2),
    gap: 8
  },
  gerenteButton: {
    fontWeight: 700,
  },
  alterarLado: {
    left: 0,
    right: "inherit",
    flexDirection: "row-reverse"
  },
  saibaMais : {
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  }
}));
